import {useState, useEffect} from 'react';
import {APIError, UnsafeAPIResponse} from './useApi';
import {handleResponse as handleAPIResponse} from '../ext/common/rest-api-helper';
import propEq from 'ramda/src/propEq';
import includes from 'ramda/src/includes';

const isError = propEq('@@type', 'Error');

function isAdminIncluded(response: UnsafeAPIResponse<string[]>): boolean {
  if (response === undefined) {
    return false;
  } else if (isError(response as APIError)) {
    console.error('Unable to determine if user is an admin: %o', response);
    return false;
  } else {
    return includes('Admin', response as string[]);
  }
}

export function useIsAdmin(apiToken: string|undefined): boolean {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (apiToken) {
      fetch('/api/v1/auth/roles', {
        headers: {Authorization: apiToken}
      }).then(handleAPIResponse as (_: Response) => Promise<string[]>)
        .then(isAdminIncluded)
        .then(setIsAdmin)
        .catch((err: Error) => {
          console.error('Unable to make admin determiniation. Failing with non-admin state.: %o', err);
          setIsAdmin(false);
        });
    } else {
      setIsAdmin(false);
    }
  }, [apiToken]);

  return isAdmin;
}
